/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice\src\Content\chatgpt\priceList.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice
 * Created Date: Wednesday July 17th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday July 17th 2024 11:00:38 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, Table, Button } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import translator from "MultiLanguage/TranslationWrapper";
import { PriceListRefType } from "Types/pricing.type";
import { getThemeColor } from "Utils/ThemeColor";
import { hightlightType } from "../Slider/PricingHolder";

type priceListProps = {
    setup: PriceListRefType;
    themeColor: string;
    hightlight: hightlightType;
    type: "LOA" | "LLD";
    setter: React.Dispatch<React.SetStateAction<hightlightType>>;
    // setterMileage: React.Dispatch<React.SetStateAction<number>>;
    // setterMonth: React.Dispatch<React.SetStateAction<number>>;
};

export default function priceList(props: priceListProps) {
    const [months, setMonths] = useState<number[]>([]);
    const [mileage, setMileage] = useState<number[]>([]);
    const tarif = useRef<PriceListRefType>({});
    const themeColor = getThemeColor(props.themeColor);

    useEffect(() => {
        if (props.setup && Object.values(props.setup).length > 0) {
            const tmp: number[] = [];
            Object.values(props.setup).forEach(val => Object.keys(val).forEach(x => tmp.push(parseInt(x))));
            setMonths([...new Set(tmp)]);
            setMileage(Object.keys(props.setup).map(x => parseInt(x)));
            tarif.current = props.setup;
        }
    }, [props.setup]);

    const mileageRow = useMemo(() => {
        return mileage.map(x => <TableCell key={Math.random()} align="center" >
                {x} {translator.decode("pricing.mileage")}
            </TableCell>)
    }, [mileage]);

    const handleSelect = (mileage: number, month: number) => {
        props.hightlight[props.type].mileage = mileage;
        props.hightlight[props.type].month = month;
        props.setter({...props.hightlight});
        // props.setterMileage(mileage);
        // props.setterMonth(month);
    };

    return (
        <TableContainer elevation={4} component={Paper}>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell />
                        {mileageRow}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {months.map((m) => (
                        <TableRow key={m} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">
                                {m} {translator.decode("pricing.month")}
                            </TableCell>
                            {mileage.map(km =>
                                <TableCell key={Math.random()} align="center">
                                    {tarif.current[km]?.[m] ?
                                        (
                                            props.hightlight[props.type].mileage == km && props.hightlight[props.type].month == m ?
                                                <Button onClick={() => handleSelect(km, m)} style={{color: "white", backgroundColor: themeColor}} variant="contained">{Math.abs(tarif.current[km]?.[m])}</Button>
                                                :
                                                <Button onClick={() => handleSelect(km, m)} style={{color: themeColor}} variant="text">{Math.abs(tarif.current[km]?.[m])}</Button>
                                        )
                                        : "N/C"
                                    }
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
};
